// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__L4vG0 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Stake/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;AACF","sourcesContent":[".wrapper {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  gap: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__L4vG0`
};
export default ___CSS_LOADER_EXPORT___;
